import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import Offer from '../../models/Offer.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const Edit = () => {
  let offerObj = new Offer();
  const [offer, setOffer] = useState(offerObj.toStateJson());
  const [fetchApi] = getApi('showOffer')
  const [updateApi] = getApi('updateOffer');

  const navigate = useNavigate();
  const params = useParams();

  const getRecord = async (params) => {
    try {
      let response = await fetchApi(params).unwrap();
      setOffer((new Offer(response.data.offer, 1)).toStateJson());
    } catch (error) {
      toast.error(error);
    }
  }

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      toast.success('Offer Updated Successfully');
      navigate("/offers");
    } catch (error) {
      setOffer((prev_state) => {
        return {
          ...prev_state,
          errors: error.data.data.errors,
        }
      })
    }
  }

  const handleSubmitFunction = () => {
    try{
      updateRecord(new Offer(offer, 3).toApiJson());
    } catch(error){
      toast.error(error.toString());
    }
  }

  const handleCancelFunction = () => {
    navigate('/offers');
  }

  return <PageContentWrapper contentHeading={"Update Offer"}>
    <div className='m-3'>
      <div className='mb-4 col-md-12'>
        <form className="row g-3" autoComplete="off">
          <FormPartial offer={offer} setOffer={setOffer} />
          <div className='mb-4 col-md-12'>
            <div >
              <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Update Offer</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </PageContentWrapper>
}

export default Edit;
